import React, { PropTypes } from 'react';

const Image = ({ alt, image, onClick }) => {
  const thumb = image.replace(/original/, 'w350');
  return (
    <a
      className="content__image-list__item" href={image}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      <img alt={alt} src={thumb} />
    </a>
  );
};

export default Image;

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./js/components/clickableImages/Image.js